const Header = (props) =>{

    // Can't simply pull-in header HTML since AWS Bucket CORs settings block it (it's NOT a PUBLIC API). Have to call in script using <script> in <meta> - "crossorigin" attribute is omitted, so those resources can be used without CORs error.

    return(
        <></>
    );
}

export default Header;